export default __webpack_public_path__ + "assets/ccd2d966b50f410985282a782c1571b2.png";